'use client';
'use strict';

require('react');
var createSafeContext = require('../../core/utils/create-safe-context/create-safe-context.cjs');
require('clsx');
require('@mantine/hooks');
require('../../core/MantineProvider/Mantine.context.cjs');
require('../../core/MantineProvider/default-theme.cjs');
require('../../core/MantineProvider/MantineProvider.cjs');
require('../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.cjs');
require('../../core/Box/Box.cjs');
require('../../core/DirectionProvider/DirectionProvider.cjs');

const [ScrollAreaProvider, useScrollAreaContext] = createSafeContext.createSafeContext(
  "ScrollArea.Root component was not found in tree"
);

exports.ScrollAreaProvider = ScrollAreaProvider;
exports.useScrollAreaContext = useScrollAreaContext;
//# sourceMappingURL=ScrollArea.context.cjs.map
